function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 14V7C18.9953 5.41016 18.3616 3.8868 17.2374 2.7626C16.1132 1.63841 14.5898 1.00475 13 1V1C11.4102 1.00475 9.8868 1.63841 8.7626 2.7626C7.63841 3.8868 7.00475 5.41016 7 7V14",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 14H1V31H25V14Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13 24V27",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13 24C14.6569 24 16 22.6569 16 21C16 19.3431 14.6569 18 13 18C11.3431 18 10 19.3431 10 21C10 22.6569 11.3431 24 13 24Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Lock.03af6ff5.svg";
export { ForwardRef as ReactComponent };